import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { creditNumericValue } from '../credit/creditNumericValue'
import { creditEconomicMovementObject } from '../creditEconomicMovement/creditEconomicMovementObject'

export const creditSoldProductObject = z.object({
  id: z.string().uuid(),
  creditEconomicMovementId: creditEconomicMovementObject.shape.id,
  description: z.string(),
  commercialUnit: z.string().nullish(),
  quantity: creditNumericValue,
  totalValue: creditNumericValue,
  sourceFilter: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const creditSoldProductCreateInputObject = creditSoldProductObject
  .pick({
    id: true,
    creditEconomicMovementId: true,
    description: true,
    commercialUnit: true,
    quantity: true,
    totalValue: true,
  })
  .extend({
    id: creditSoldProductObject.shape.id.nullish(),
  })

export const creditSoldProductUpdateInputObject = creditSoldProductObject
  .pick({
    id: true,
    creditEconomicMovementId: true,
    description: true,
    commercialUnit: true,
    quantity: true,
    totalValue: true,
  })
  .partial()
  .required({ id: true })

export type CreditSoldProductType = z.infer<typeof creditSoldProductObject>

export const propertyMap = {
  id: sql`credit_sold_product.id`,
  creditEconomicMovementId: sql`credit_sold_product.credit_economic_movement_id`,
  description: sql`credit_sold_product.description`,
  commercialUnit: sql`credit_sold_product.commercial_unit`,
  quantity: sql`credit_sold_product.quantity`,
  totalValue: sql`credit_sold_product.total_value`,
  sourceFilter: sql`credit_sold_product.source_filter`,
  createdAt: sql`credit_sold_product.created_at`,
  updatedAt: sql`credit_sold_product.updated_at`,
  deletedAt: sql`credit_sold_product.deleted_at`,
}

export default creditSoldProductObject

